import { handleActions } from "redux-actions";
import {
  getDateRanges,
  getRangeOptions,
  getRangeOptionsWithCustom,
  getSelectedRangeOptionWithCustom,
  getThisYear
} from "../../../../../utils/date-range-options";
import {
  MEMBERSHIP_METRIC_MAPPING,
  membershipMetricOptions,
  METRIC_PARAMS
} from "../membershipMetricSettings/membershipMetricSettings";
import {
  FETCH_CHART_SUCCESS,
  FETCH_CURRENT_USER_SUCCESS,
  FETCH_TOTAL_SUCCESS,
  FETCH_POS_MODAL_DATA_SUCCESS,
  FETCH_TABLECHART_SUCCESS,
  FETCH_FILTERS_SUCCESS,
  SET_MEMBERSHIP_LOGIC,
  SET_FILTERS_LOADING,
  SET_UPDATES_LOADING,
  SET_FILTERS_DIRTY,
  SET_LEARN_CONTENT,
  SET_LOADING,
  SET_DATES,
  UPDATE_MEMBERSHIP_METRIC_FILTER,
  UPDATE_TABLE_VIEW_SELECTED,
  UPDATE_CUSTOM_RANGE,
  UPDATE_PERIOD_TYPE,
  UPDATE_DATES,
  UPDATE_FILTERS,
  RESET_FILTER_SELECTED
} from "./numberOfActiveMembersBySagas";

export const initialState = {
  currentUser: {},
  initialRequest: false,
  tableChartData: {},
  chartData: {},
  filters: {
    group_by: [],
    membership_types: []
  },
  totalData: {},
  posTableData: {},
  isLoading: true,
  updatesLoading: false,
  frozenTableData: {},
  filtersDirty: false,
  selectedRequestDates: {},
  selectedFilters: {
    period_type: "Daily",
    table_view: false,
    group_by: { id: "by_membership_type", name: "By Membership Type" },
    membership_types: []
  },
  periodTypeOptions: ["Daily", "Monthly"],
  selectedRangeOption: {
    id: 1,
    name: getThisYear(undefined, true)
  },
  rangeOptions: [],
  membershipMetricOptions: [],
  selectedMembershipMetric: {},
  membership_types: [],
  group_by: [],
  showNoDataMessage: false,
  metric_params: {
    apiPath: "",
    showPosModal: false,
    showLearnText: false,
    iLearnContent: null
  }
};

const getMembershipMetricOptions = (availibleOptions) => {
  return membershipMetricOptions.filter((option) =>
    availibleOptions.some((name) => name === option.name)
  );
};

export default handleActions(
  {
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [SET_FILTERS_LOADING]: (state, action) => ({
      ...state,
      isFiltersLoading: action.payload
    }),
    [SET_UPDATES_LOADING]: (state, action) => ({
      ...state,
      updatesLoading: action.payload
    }),
    [SET_DATES]: (state, action) => {
      let rangeOptions = getRangeOptions(
        state.currentUser.calendarEndDate,
        state.currentUser.theBeginningOfTime
      );
      return {
        ...state,
        selectedRequestDates: action.payload || state.selectedRequestDates,
        rangeOptions: getRangeOptionsWithCustom(rangeOptions, action),
        selectedRangeOption: getSelectedRangeOptionWithCustom(action)
      };
    },
    [UPDATE_DATES]: (state, action) => ({
      ...state,
      selectedRequestDates: action.payload || state.selectedRequestDates,
      filtersDirty: true,
      rangeOptions: getRangeOptionsWithCustom(state.rangeOptions, action),
      selectedRangeOption: getSelectedRangeOptionWithCustom(action)
    }),
    [SET_FILTERS_DIRTY]: (state, action) => ({
      ...state,
      filtersDirty: action.payload
    }),
    [SET_LEARN_CONTENT]: (state, action) => ({
      ...state,
      metric_params: {
        ...state.metric_params,
        iLearnContent: action.payload
      }
    }),

    [SET_MEMBERSHIP_LOGIC]: (state, action) => {
      const { availableOptions, selectedOptionByDefault } =
        MEMBERSHIP_METRIC_MAPPING[action.payload];
      const membershipMetricOptions = getMembershipMetricOptions(availableOptions);
      const selectedMetricOption = membershipMetricOptions.filter(
        ({ name }) => name === selectedOptionByDefault
      );
      return {
        ...state,
        membershipMetricOptions: membershipMetricOptions,
        selectedMembershipMetric: selectedMetricOption[0],
        metric_params: {
          ...METRIC_PARAMS[action.payload]
        }
      };
    },
    [FETCH_POS_MODAL_DATA_SUCCESS]: (state, action) => ({
      ...state,
      posTableData: action.payload
    }),
    [RESET_FILTER_SELECTED]: (state) => ({
      ...state,
      filtersDirty: false,
      selectedFilters: { ...initialState.selectedFilters },
      filtersOptions: {}
    }),
    [FETCH_CURRENT_USER_SUCCESS]: (state, action) => ({
      ...state,
      currentUser: action.payload,
      initialRequest: true
    }),
    [UPDATE_FILTERS]: (state, action) => ({
      ...state,
      filtersDirty: true,
      selectedFilters: { ...state.selectedFilters, ...action.payload }
    }),
    [FETCH_FILTERS_SUCCESS]: (state, action) => {
      return {
        ...state,
        filters: { ...action.payload, membership_types: action.payload.membership_types },
        selectedFilters: {
          ...state.selectedFilters,
          membership_types: action.payload.membership_types
        },
        showNoDataMessage: !action.payload.membership_types.length
      };
    },
    [FETCH_CHART_SUCCESS]: (state, action) => {
      if (action.payload.options?.doubleTableView) {
        const { data_table, options } = action.payload;
        return {
          ...state,
          chartData: { data_table: { ...data_table.total }, options },
          frozenTableData: { ...data_table.frozen }
        };
      }
      return {
        ...state,
        chartData: action.payload
      };
    },
    [FETCH_TABLECHART_SUCCESS]: (state, action) => ({
      ...state,
      tableChartData: action.payload
    }),
    [FETCH_TOTAL_SUCCESS]: (state, action) => ({
      ...state,
      totalData: action.payload
    }),
    [UPDATE_TABLE_VIEW_SELECTED]: (state, action) => ({
      ...state,
      selectedFilters: {
        ...state.selectedFilters,
        table_view: action.payload
      }
    }),
    [UPDATE_CUSTOM_RANGE]: (state, action) => ({
      ...state,
      selectedRangeOption: action.payload,
      selectedRequestDates: getDateRanges(
        state.currentUser.calendarEndDate,
        action.payload,
        state.currentUser.theBeginningOfTime
      ),
      filtersDirty: true
    }),

    [UPDATE_PERIOD_TYPE]: (state, action) => ({
      ...state,
      filtersDirty: true,
      selectedFilters: {
        ...state.selectedFilters,
        period_type: action.payload
      }
    }),
    [UPDATE_MEMBERSHIP_METRIC_FILTER]: (state, action) => ({
      ...state,
      selectedMembershipMetric: action.payload,
      metric_params: {
        ...state.metric_params,
        ...METRIC_PARAMS[action.payload.metric],
        metric: action.payload.metric
      },
      showNoDataMessage: false
    })
  },
  initialState
);
